<template>
    <div class="index" id="indexDiv" ref="indexDiv" >
      <div  >
        <el-button type="primary" size="small" class="btnBigScreen" @click="openBigScreen"  >中心大屏</el-button>
        <el-tabs v-model="logSearchForm.activeName" @tab-click="handleClick" >
          <el-tab-pane label="救助记录" name="1" >
            <el-form size="mini">
              <el-row >
                <el-form-item label="地区" style="width: 250px; float: left;" >
                  <GetArea v-if="isShowRoleArea" :hierarchy="area_hierarchy" :type="'edit'" ref="GetLogArea" :province="l_prov" :city="l_city" :county="l_county" @getArea="getLogSearchAreaItem('area', $event)" :defaultData="defaultAreaArr" ></GetArea>
                </el-form-item>
                <el-form-item label="发起方姓名/ID/紧急联系人电话" style="width: 400px; float: left;"   >
                    <el-input v-model="logSearchForm.wakenQ" placeholder="请输入" clearable style="width: 180px;"></el-input>
                </el-form-item>
                <el-form-item label="发起时间" style="width:310px;float: left;" >
                  <GetDate ref="GetLogDate" title="" @getDate="getLogSearchItem('dateRect', $event)" ></GetDate>
                </el-form-item>
                <el-form-item label="发起设备编号/名称" style="width: 280px; float: left;"   >
                    <el-input v-model="logSearchForm.deviceId" placeholder="请输入" clearable style="width: 150px;"></el-input>
                </el-form-item>
              </el-row>
              <el-row >
                <el-form-item label="接线员/接线员电话" style="width: 295px; float: left;"   >
                    <el-input v-model="logSearchForm.serviceQ" placeholder="请输入" clearable style="width: 150px;"></el-input>
                </el-form-item>
                <el-form-item label="编号" style="width: 250px; float: left;" >
                  <el-input v-model="logSearchForm.id" placeholder="请输入编号" clearable style="width: 180px;"></el-input>
                </el-form-item>
                <el-button type="primary" size="mini" @click="gotoLogSearch" >查询</el-button>
                <el-button type="default" size="mini" @click="gotoLogResetSearch" >重置</el-button>
              </el-row>
            </el-form>
            <div class="dataArea" style="margin-top: 15px;">
              <el-table :data="logTableData" size="mini" header-cell-class-name="logHeaderClass" >
                  <el-table-column prop="id" label="编号" width="150" ></el-table-column>
                  <el-table-column prop="insertTime" label="发起时间" width="135" ></el-table-column>
                  <el-table-column prop="wakenName" label="发起方姓名" width="120"></el-table-column>
                  <el-table-column prop="wakenId" label="发起方ID" width="150"></el-table-column>
                  <el-table-column label="发起方紧急联系人电话" width="135">
                    <template scope="temp" >
                      <span >{{filterTelView(temp.row.wakenMobile)}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="现场照片" width="150">
                    <template  scope="temp" >
                      <div class="sceneImgDiv" v-if="temp.row.photos" @click="showBigImgView(temp.row.photos)" >
                        <img :src="getArrFirstImg(temp.row.photos)">
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="deviceName" label="设备名称" width="120"></el-table-column>
                  <el-table-column prop="deviceId" label="设备ID" width="120"></el-table-column>
                  <el-table-column label="设备地区" width="150">
                    <template  scope="temp" >
                      <span >{{showDeviceArea(temp.row)}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="serviceName" label="接线员" width="150"></el-table-column>
                  <el-table-column label="接线员电话" width="120">
                    <template  scope="temp" >
                      <span >{{filterTelView(temp.row.serviceMobile)}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="通话时长" width="120">
                    <template  scope="temp" >
                      <span >{{filterTimelong(temp.row)}}</span>
                    </template>
                  </el-table-column>
              </el-table>
              <Pagination
                style="padding: 0; margin: 0;"
                :total="logPageData.total"
                :page.sync="logPageData.page"
                :limit.sync="logPageData.limit"
                @pagination="logPaginationQueryPage"
              />
            </div>
          </el-tab-pane>
          <el-tab-pane label="接线员设置" name="2" >
            <el-form size="mini">
              <el-row >
                <el-col :span="4" >
                  <el-form-item label="地区">
                    <GetArea v-if="isShowRoleArea" :hierarchy="area_hierarchy" ref="GetServiceArea" :type="'edit'" :province="l_prov" :city="l_city" :county="l_county" @getArea="getServiceSearchAreaItem('area', $event)" :defaultData="defaultAreaArr" ></GetArea>
                  </el-form-item>
                </el-col>
                <el-col :span="5" >
                  <el-form-item label="接线员姓名/电话">
                    <el-input placeholder="姓名/电话" v-model="serviceSearchForm.name" clearable style="width: 180px;" ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="5" >
                  <el-form-item label="创建时间">
                    <GetDate ref="GetDate" title="" @getDate="getServiceSearchItem('dateRect', $event)" ></GetDate>
                  </el-form-item>
                </el-col>
                <el-col :span="3" >
                  <el-form-item label="启用状态">
                    <el-select v-model="serviceSearchForm.status" placeholder="请选状态" style="width: 100px;" clearable >
                      <el-option v-for="item in statusArr" :key="item.val" :value="item.val" :label="item.name" ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4" >
                  <el-button type="primary" size="mini" @click="gotoSearchService" >查询</el-button>
                  <el-button type="default" size="mini" @click="gotoServiceResetSearch" >重置</el-button>
                </el-col>
              </el-row>
              <el-row >
                <el-col :span="8" style="padding-top: 10px;" >
                  <el-button type="primary" size="mini" @click="showAddServiceWin" >添加接线员</el-button>
                  <span style="margin-left: 10px;" >接线规则采用轮流方式，按照接线员创建时间依次接听。</span>
                </el-col>
              </el-row>
            </el-form>
            <div class="dataArea" style="margin-top: 15px;">
              <el-table :data="serviceTableData" size="mini" >
                  <el-table-column prop="insertTime" label="添加时间" width="135" ></el-table-column>
                  <el-table-column prop="name" label="接线员姓名" ></el-table-column>
                  <el-table-column prop="mobile" label="接线员电话" width="120"></el-table-column>
                  <el-table-column label="负责地区" >
                    <template scope="temp" >
                      <span >{{showAreaName(temp.row)}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="" label="是否启用" width="100" align="center">
                    <template scope="temp" >
                      <span v-if="temp.row.status==1" style="color: green;" >启用中</span>
                      <span v-if="temp.row.status==0" style="color: orange; " >禁用中</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="160" align="center" >
                    <template scope="temp" >
                      <span v-if="temp.row.status==1" class="opbtn" @click="gotoUpdServiceStatus(temp.row)" >禁用</span>
                      <span v-if="temp.row.status==0" class="opbtn" @click="gotoUpdServiceStatus(temp.row)" >启用</span>
                      <span class="opbtn" @click="showEditServiceWin(temp.row)" >修改</span>
                      <span class="opbtn" @click="gotoDelService(temp.row)" >删除</span>
                    </template>
                  </el-table-column>
              </el-table>
              <Pagination
                style="padding: 0; margin: 0;"
                :total="servicePageData.total"
                :page.sync="servicePageData.page"
                :limit.sync="servicePageData.limit"
                @pagination="servicePaginationQueryPage"
              />
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <el-dialog :title="editServiceTitle" :visible.sync="isShowAddService" width="800px" :before-close="handleServiceWinClose" top="1vh"  :close-on-click-modal="false" >
        <el-form :model="serviceEditData" ref="serviceEditData" label-width="110px" class="demo-ruleForm" size="mini">
          <el-row >
            <el-col :span="14" >
              <el-form-item label="姓名" >
                <el-input placeholder="请输入接线员姓名" v-model="serviceEditData.name" clearable></el-input>
              </el-form-item>
              <el-form-item label="手机号码" >
                <el-input placeholder="请输入手机号码" v-model="serviceEditData.mobile" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row >
            <el-col :span="24" >
              <el-form-item label="负责地区" >
                <el-checkbox v-model="isZbCheck"  style="float: left; margin-right: 10px;" value="00" @change="changeServiceZb" v-if="userRole=='admin'" >总部</el-checkbox>
                <span style="float: left;" v-if="userRole=='admin'">｜其他城市：</span>
                <GetArea ref="GetArea" :type="'edit'" :hierarchy="area_hierarchy" @getArea="getServiceEditAreaItem('area', $event)" :defaultData="serviceEditArea" style="width: 200px; float: left;" :province="l_prov" :city="l_city" :county="l_county" ></GetArea>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row >
            <el-col :span="14" >
              <el-form-item label="是否启用">
                <el-select v-model="serviceEditData.status" placeholder="请选择" style="width: 100px;"  >
                  <el-option v-for="item in statusArr" :key="item.val" :value="item.val" :label="item.name" ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row >
            <el-col >
              <hr style="width: 100%;border:1px solid #f3f3f3;" />
            </el-col>
          </el-row>
          <el-row >
            <el-col :span="14" >
              <el-form-item>
                <el-button type="primary" @click="gotoSaveService">保存</el-button>
                <el-button @click="cancelServiceEdit" >取消</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-dialog>

      <el-dialog title='查看紧急呼叫图片' :visible.sync="bigImgViewVisibile" width="700px" :before-close="closeBigImgView" top="1vh"  :close-on-click-modal="false" >
        <el-carousel height="700px" trigger="click" >
          <el-carousel-item v-for="(imgUrl,index) in bigImages" :key="index">
            <img :src="imgUrl" alt="">
          </el-carousel-item>
        </el-carousel>
      </el-dialog>
      
    </div>
  </template>
  <script>
  import Pagination from '@/components/Pagination'
  import GetDate from "@/views/components/search/GetDate"
  import GetArea from "@/views/components/search/GetArea"
  import { getAreaMap, getSosServicePage, saveService, delService, updServiceUse, getSosLogPage, getUserRoleType } from "@/api/zjdevices.js"
  import { Message } from 'element-ui';
  import loadingImgPath from '@/assets/img/loading.gif';
  export default {
    components: { Pagination, GetDate, GetArea },
    data() {
      return {
        serviceSearchForm:{
          activeName: "1", // 显示的panel
          dateRect: "", // 日期区间
          name: "", // 接线员姓名或电话
          callStatus: null,
          status: null,
        },
        serviceTableData:[],
        servicePageData:{
          page: 1,
          limit: 10,
          total: 0,
        },
        bigImages:[], // 预览大图
        bigImgViewVisibile: false, // 是否显示预览大图
        bigImgViewHeight: 0, // 预览图区域高度
        bigImgScrollTop: 0, // 记录滚动条位置
        editServiceTitle: "添加接线员", // 
        isShowAddService: false , // 是否显示添加接线员窗口
        serviceEditData:{
          name:"",mobile:"",status:null,
        } , // 接线员编辑内容
        isZbCheck: 0, // 是否选中了总部
        userRole: null, // 用户角色
        statusArr:[{val:"",name:"全部"}, {val:1,name:"启用"}, {val:0,name:"禁用"}], // 可用状态
        serviceEditArea: [], // 回显区域
        logSearchForm:{
          activeName: "1", // 显示的panel
          dateRect: "", // 日期区间
          name: "", // 接线员姓名或电话
        },
        logPageData:{
          page: 1,
          limit: 10,
          total: 0,
        },
        logTableData:[], // 日志列表
        area_hierarchy:2, // 区域层级
        defaultAreaArr:null, // 默认区域
        isShowRoleArea: false, //
        l_prov:"",
        l_city:"",
        l_county:"",
      }
    },
    created() {
    },
    mounted() {
      let that = this;
      // this.isShowRoleArea=true;
      // 获取角色信息
      // this.getLoginUserRoleTypeOnLoad();
      // 获取地区映射
      this.gotoGetAreaData();
      this.getLoginUserRoleTypeOnLoad();
      // 查询日志
      setTimeout(function(){
        that.gotoLogSearch();
      },1500);
    },
    methods:{
      // 获取地区映射
      gotoGetAreaData(){
        let that = this;
        getAreaMap().then(function(rdata){
          var  rs = rdata.data;
          var json = rs.data;
          that.areaMap = JSON.parse(json);
        });
      },
      handleClick(tab, event) {
        // 获取角色信息
        this.getLoginUserRoleTypeOnLoad();
        if (tab.name == "1") {
          // 救助记录
          this.gotoLogSearch();
        }else if(tab.name=="2"){
          this.gotoSearchService();
        }
        
      },
      doServiceSearch(){
      },
      doReset(){
      },
      // 日志查询分页
      logPaginationQueryPage(){
        this.gotoLogSearch();
      },
      // 接线员分页
      servicePaginationQueryPage(){
        this.gotoSearchService();
      },
      changeSearchFormDate(key, value) {
        if(value!=null && value.length>1){
          if(value[0].length>10){
            value[0] = value[0].substring(0,10);
          }
          if(value[1].length>10){
            value[1] = value[1].substring(0,10);
          }
        }
        this.$set(this.searchForm, key, value)
      },
      getServiceSearchAreaItem(key, value) {
        this.$set(this.serviceSearchForm, key, value)
      },
      getLogSearchAreaItem(key, value){
        this.$set(this.logSearchForm, key, value)
      },
      getServiceSearchItem(key, value) {
        this.$set(this.serviceSearchForm, key, value)
      },
      getLogSearchItem(key, value) {
        this.$set(this.logSearchForm, key, value)
      },
      // 搜索接线员
      gotoSearchService(){
        let that = this;
        var provId=null;
        var cityId=null;
        if(this.serviceSearchForm.area && this.serviceSearchForm.area.length>1){
          cityId = this.serviceSearchForm.area[1];
        }
        if(this.serviceSearchForm.area!=null && this.serviceSearchForm.area.length>0){
          provId = this.serviceSearchForm.area[0];
        }
        var dataArr = null;
        if(this.serviceSearchForm.dateRect!=null && this.serviceSearchForm.dateRect!="" && this.serviceSearchForm.dateRect.length>1){
          dataArr = this.serviceSearchForm.dateRect;
        }
        var params = {
          q: this.serviceSearchForm.name,
          page : this.servicePageData.page,
          limit : this.servicePageData.limit,
          provId: provId,
          cityId: cityId,
          startDate: dataArr?dataArr[0]:null,
          endDate: dataArr?dataArr[1]:null,
          callStatus: this.serviceSearchForm.callStatus,
          status: this.serviceSearchForm.status,
        };
        getSosServicePage(params).then(function(rdata){
          var rs = rdata.data;
          if(rs.code==0){
            let pageData = rs.data;
            that.serviceTableData = pageData.records;
            that.servicePageData.total = pageData.total;
          }else{
            that.$message({
              type: 'error',
              message: rs.msg
            });
          }
        });
      },
      // 重置接线员搜索条件
      gotoServiceResetSearch(){
        this.serviceSearchForm.name="";
        this.$refs.GetDate.date = [];
        this.serviceSearchForm.dateRect = [];
        this.$refs.GetServiceArea.value = [];
        this.serviceSearchForm.area = [];
        this.serviceSearchForm.callStatus=null;
        this.serviceSearchForm.status=null;
      },
      // 显示区域名称
      showAreaName(row){
        if(row.cityId=="0000"){
          return "总部接线员";
        }
        var provName = this.areaMap[parseInt(row.provId)];
        if(provName==null){
          return "--";
        }
        var cityName = this.areaMap[row.cityId];
        var nameVal = provName+(cityName=="市辖区"?"":cityName);
        return nameVal;
      },
      // 关闭接线员编辑窗口
      handleServiceWinClose(){
        this.isShowAddService = false;
      },
      // 保存接线员信息
      gotoSaveService(){
        let that = this;
        if(this.serviceEditData.name==null || this.serviceEditData.name==""){
          that.$message({ type: 'warning', message: '请输入姓名' });
          return;
        }
        console.log("this.serviceEditData.area", this.serviceEditData.area);
        if(this.serviceEditData.area==null || this.serviceEditData.area.length<2){
          that.$message({ type: 'warning', message: '请选择负责地区' });
          return;
        }
        if(this.serviceEditData.mobile==null || this.serviceEditData.mobile==""){
          that.$message({ type: 'warning', message: '请输入手机号码' });
          return;
        }
        var mobile = this.serviceEditData.mobile;
        var regex = /^1[3-9]\d{9}$/;
        if(!regex.test(mobile)){
          that.$message({ type: 'warning', message: '手机号码格式错误' });
          return;
        }
        var params={
          id: this.serviceEditData.id,
          name: this.serviceEditData.name,
          provId: this.serviceEditData.area[0],
          cityId: this.serviceEditData.area[1],
          status: this.serviceEditData.status,
          mobile: this.serviceEditData.mobile,
        }
        saveService(params).then(function(rdata){
          var rs=rdata.data;
          if(rs.code=="0"){
              that.$message({
                  type: 'success',
                  message: '保存成功'
              });
              // 关闭窗体
              that.cancelServiceEdit();
              // 重新加载数据
              that.gotoSearchService();
          }else{
              that.$message({
              type: 'error',
              message: rs.msg
              });
          }
        });
      },
      // 重置接线员编辑窗口
      resetServiceEdit(){
        // 
      },
      // 取消接线员编辑，关闭窗口
      cancelServiceEdit(){
        this.isShowAddService = false;
      },
      // 同步区域选择
      getServiceEditAreaItem(key, value) {
        this.$set(this.serviceEditData, key, value)
        this.isZbCheck = false;
      },
      // 显示
      showAddServiceWin(){
        this.editServiceTitle = "添加接线员";
        this.serviceEditData.id = null;
        this.serviceEditData.name = "";
        this.serviceEditData.mobile = "";
        this.serviceEditData.status = 1;
        this.serviceEditData.area = [];
        let that = this;
        setTimeout(function(){
          that.$refs.GetArea.value = [];
          if(that.userRole!='admin'){
            // 不是超管
            // 限制区域范围
            that.serviceEditArea = that.defaultAreaArr;
            that.$refs.GetArea.value = that.defaultAreaArr;
            that.l_prov=that.defaultAreaArr[0]+"";
            that.l_city=that.defaultAreaArr[1]+"";
            that.serviceEditData.area = that.defaultAreaArr;
          }else{
            // 超级管理员
          }
        },500)
        this.isShowAddService = true;
        
      },
      showEditServiceWin(row){
        let that = this;
        this.editServiceTitle = "编辑接线员";
        this.serviceEditData = row;
        this.isShowAddService = true;
        if(row.provId && row.cityId && row.cityId!='0000'){
          if(!this.$refs.GetArea){
            this.$refs.GetArea=[];
          }
          this.$refs.GetArea.value = [parseInt(row.provId),parseInt(row.cityId)];
          this.serviceEditData.area = [parseInt(row.provId),parseInt(row.cityId)];
          this.serviceEditArea = [parseInt(row.provId), parseInt(row.cityId)];
          this.isZbCheck = false;
        }else{
          this.isZbCheck = true;
          this.serviceEditArea = ["00", "0000"];
          this.serviceEditData.area = ["00", "0000"];
          this.$refs.GetArea.value = ["00", "0000"];
        }
        setTimeout(function(){
          if(that.userRole!='admin'){
            // 不是超管
            // 限制区域范围
            that.serviceEditArea = that.defaultAreaArr;
            that.$refs.GetArea.value = that.defaultAreaArr;
            that.l_prov=that.defaultAreaArr[0]+"";
            that.l_city=that.defaultAreaArr[1]+"";
          }
        },500)
      },
      // 删除接线员
      gotoDelService(row){
        let that = this;
        var name = row.name;
        if(name==null){
          name="";
        }
        this.$confirm("确认删除接线员"+name+", 是否继续?", "提示", {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var params = { id: row.id };
          delService(params).then(function(rdata){
            var rs = rdata.data;
            if(rs.code=="0"){
              that.$message({  type: 'success',  message: '删除成功!' });
              // 重新加载数据
              that.gotoSearchService();
            }else{
              that.$message({  type: 'error',  message: '操作失败!' });
            }
          });
        }).catch(() => {
        });
      },
      // 更新接线员的状态
      gotoUpdServiceStatus(row){
        let that = this;
        var params = { id: row.id };
        updServiceUse(params).then(function(rdata){
          var rs = rdata.data;
          if(rs.code=="0"){
            // 重新加载数据
            that.gotoSearchService();
          }
        });
      },
      // 是否选中了总部
      changeServiceZb(){
        if(this.isZbCheck){
          this.serviceEditArea = ["00", "0000"];
          this.serviceEditData.area = ["00", "0000"];
          this.$refs.GetArea.value = ["00", "0000"];
        }
      },
      // 日志查询
      gotoLogSearch(){
        let that = this;
        var provId=null;
        var cityId=null;
        if(this.logSearchForm.area && this.logSearchForm.area.length>1){
          cityId = this.logSearchForm.area[1];
        }
        if(this.logSearchForm.area!=null && this.logSearchForm.area.length>0){
          provId = this.logSearchForm.area[0];
        }
        var dataArr = null;
        if(this.logSearchForm.dateRect!=null && this.logSearchForm.dateRect!="" && this.logSearchForm.dateRect.length>1){
          dataArr = this.logSearchForm.dateRect;
        }
        var params = {
          page : this.logPageData.page,
          limit : this.logPageData.limit,
          provId: provId,
          cityId: cityId,
          wakenQ : this.logSearchForm.wakenQ,
          serviceQ: this.logSearchForm.serviceQ,
          startDate: dataArr?dataArr[0]:null,
          endDate: dataArr?dataArr[1]:null,
          deviceId: this.logSearchForm.deviceId,
          id: this.logSearchForm.id,
        }
        getSosLogPage(params).then(function(rdata){
          var rs = rdata.data;
          if(rs.code==0){
            let pageData = rs.data;
            that.logTableData = pageData.records;
            that.logPageData.total = pageData.total;
          }else{
            that.$message({
              type: 'error',
              message: rs.msg
            });
          }
        })
      },
      // 日志查询条件重置
      gotoLogResetSearch(){
        this.$refs.GetLogDate.date = [];
        this.logSearchForm.dateRect = [];
        this.$refs.GetLogArea.value = [];
        this.logSearchForm.area = [];
        this.logSearchForm.wakenQ = "";
        this.logSearchForm.serviceQ = "";
        this.logSearchForm.deviceId = "";
        this.logSearchForm.id = "";
        this.gotoLogSearch();
        this.isShowRoleArea=true;
      },
      // 过滤手机号显示
      filterTelView(tel){
        let that = this;
        if(tel && tel.length>10){
          if(tel.length>15){
            return "--";
          }
            // 前3位和后4位显示
            if(that.userRole=="admin"){
                return tel;
            }else{
                var pre = tel.substring(0,3);
                var suf = tel.substring(tel.length-4);
                return pre + "****"+suf;
            }
        }
        return "--";
      },
      // 显示设备所在区域
      showDeviceArea(row){
        var countyName="";
        var cityName="";
        var provName="";
        if(row.countyId!=null){
          countyName=this.areaMap[row.countyId];
        }
        if(row.cityId!=null){
          cityName=this.areaMap[row.cityId];
          if(cityName=="市辖区"){
            cityName="";
          }
        }
        if(row.provId!=null){
          provName=this.areaMap[row.provId];
        }
        return provName+cityName+countyName;
      },
      // 获取登录账号角色
      getLoginUserRoleTypeOnLoad(){
        let that = this;
        getUserRoleType().then(function(rs){
          var rdata = rs.data;
          if(rdata.code==0){
            var roleType = rdata.data;
            if(roleType.indexOf("admin")==0){
              // 超级管理员
              that.userRole="admin";
              that.isShowRoleArea=true;
            }else if(roleType.indexOf("20,")==0){
              // 市级代理
              that.userRole="20";
              var areaArr = roleType.split(",");
              that.defaultAreaArr=[parseInt(areaArr[1]),parseInt(areaArr[2])];
              that.l_prov=areaArr[1];
              that.l_city=areaArr[2];
              that.logSearchForm.area = [areaArr[1],areaArr[2]];
              that.serviceSearchForm.area = [areaArr[1],areaArr[2]];
              // that.$refs.GetLogArea.value = that.defaultAreaArr;
              that.isShowRoleArea=true;
            }else if(roleType.indexOf("10,")==0){
              // 县级、区级代理
              that.$message({
                type: 'error',
                message: '无权限'
              });
            }
          }else{
            that.$message({
              type: 'error',
              message: rdata.msg
            });
          }
        });
      },
      getArrFirstImg(imgUrls){
        if(imgUrls){
          var imgArr = imgUrls.split(";");
          return imgArr[0];
        }
        return "";
      },
      // 显示预览大图
      showBigImgView(imgUrls){
        if(imgUrls){
          var imgArr = imgUrls.split(";");
          if(imgArr[imgArr.length-1]==null||imgArr[imgArr.length-1]==""){
            imgArr.pop();
          }
          this.bigImages = imgArr;
          this.bigImgViewVisibile = true;
          this.bigImgViewHeight = document.body.scrollHeight;
          this.bigImgScrollTop = window.scrollY;
          console.log("this.bigImgScrollTop::", this.bigImgScrollTop);
        }else{
          that.$message({
            type: 'error',
            message: '没有可以预览的图片'
          });
        }
      },
      // 关闭图片预览
      closeBigImgView(){
        this.bigImgViewVisibile = false;
      },
      openBigScreen(){
        const features = `
          width=${screen.width},
          height=${screen.availHeight},
          top=0,
          left=0,
          toolbar=no,
          menubar=no,
          location=no,
          status=no,
          scrollbars=yes,
          resizable=yes
      `.replace(/\s+/g, '');
      console.log("features", features);
        window.open('http://www.tdskynet.com/command-center','_blank',features);
      },
      filterTimelong(row){
        var chattime=row.chatTime;
        if(chattime==null){
          return "--";
        }else{
          return row.timelong;
        }
      },
    }
  }
  </script>
<style lang="scss" scoped>

.el-form-item{
  margin-bottom: 5px;
}
</style>
<style >
.el-table th.el-table__cell {
  background-color: #f9f9f9; /* 你可以将这里设置为你想要的背景颜色 */
  color: #666; /* 你可以根据需要调整文字颜色 */
}

.tabHeader{
  font-size: 14px;
  font-weight: 500;
  height: 40px;
  line-height: 40px;
}
.itemName{
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding-right: 4px;
  font-size: 12px;
  color: #909090;
  font-weight: 600;
}

.itemVal{
  line-height: 40px;
  font-size: 12px;
  color: #909090;
}

.operateDiv{
  width: 100%;
  height: 140px;
  border-radius: 10px;
  background-color: #f6f6f6;
}
.operateItem{
  height: 70px;
  line-height: 20px;
  text-align: center;
  font-size: 14px;
  color: #589ef8;
  display: flex;
  flex-direction: column;
  justify-content: center; /* 垂直居中 */
  align-items: center; /* 水平居中 */
}
.operateName{
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  display: block;
  margin-top: 5px;
}

.gray {
  filter: grayscale(100%); /* 完全置灰 */
}
/** 图片旋转180度 */
.transform180{
  transform: rotate(180deg);
}

.upgradeDlg .el-dialog__body{
  padding-top: 0px;
  border-top: 1px solid #eeeeee;
}

.el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner{
  width: 225px;
}
.el-date-editor .el-range-separator{
  width: 10%;
}
.el-date-editor .el-range-input{
  width: 82px;
}

.opbtn{
  width:45px;height: 25px; line-height: 25px; display: inline-block; float: left; text-align: center; cursor: pointer;
}

.logHeaderClass .cell{
  height: 32px; line-height: 32px;
  background-color: #f3f3f3;
}

.sceneImgDiv{
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;     /* 垂直居中 */
}

.sceneImgDiv img{
  max-width: 100%;        /* 图片最大宽度为容器宽度 */
  max-height: 100%;       /* 图片最大高度为容器高度 */
  object-fit: contain;    /* 等比缩放图片以适应容器 */
}


.el-carousel {
  text-align: center;
}

.el-carousel__button{
  background-color: grey;
}

.is-active .el-carousel__button{
  background-color: black;
}

.btnBigScreen{
  display: flex;
  top: 15px;
  right: 30px;
  position: absolute;
  z-index: 1999;
  float: left;
}

/*** 提交个备注 */

</style>